import React from 'react';
import styled from 'styled-components';
import { theme } from '@/styles/theme/index.jsx';

const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease;

  .loader {
    width: 48px;
    height: 48px;
    border: 5px solid ${theme.colors.secondaryGreen};
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    opacity: 1;
    visibility: visible;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loading = () => {
  return (
    <LoadingWrapper id="loading-screen">
      <span className="loader"></span>
    </LoadingWrapper>
  );
};

export default Loading; 